"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyGeneralPreferences = void 0;
function applyGeneralPreferences(draft, action) {
    const { data } = action.payload;
    draft.workspaces[draft.workspace.current] = data;
}
exports.applyGeneralPreferences = applyGeneralPreferences;
